import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { ColDef } from 'ag-grid-community';
import { ChangeEvent } from 'react';
import { notNull } from '../utils';

type Props<T> = {
    available: ColDef<T>[];
    selected: string[];
    setSelected: (selectedColumns: string[]) => void;
};

export const AgCheckboxGroupPanel = <T,>({ available, selected, setSelected }: Props<T>) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>, selectedKey: string) => {
        const newSelected = event.target.checked
            ? [selectedKey, ...selected]
            : selected.filter(x => x !== selectedKey);

        const keysSelectedButNotAvailableForSelection = selected.filter(
            x => !available.some(a => a.field === x)
        );

        // Use available as source in order to use its order
        // of the selected keys
        setSelected([
            ...available.map(c => newSelected[newSelected.indexOf(c.field ?? '')]).filter(notNull),
            ...keysSelectedButNotAvailableForSelection
        ]);
    };

    return (
        <Box
            component="div"
            sx={theme => ({ display: 'flex', flexDirection: 'column', padding: theme.spacing(2) })}
        >
            {available.map(c => (
                <FormControlLabel
                    key={c.field}
                    control={
                        <Checkbox
                            checked={selected.includes(c.field ?? '')}
                            onChange={ev => handleChange(ev, c.field ?? '')}
                            name={c.headerName as string}
                            color="primary"
                            size="small"
                        />
                    }
                    label={<Typography variant="body2">{c.headerName}</Typography>}
                />
            ))}
        </Box>
    );
};
